<template>
  <div>
    <!-- 关联表弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="添加关联表"
        :visible.sync="dialogVisibleObj.addAssociative"
        :close-on-click-modal="false"
      >
        <div class="waitingcom_title">
          <el-form
            label-width="100px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :label-position="labelPosition"
          >
            <el-form-item label="评分表名称：" prop="operationName">
              <el-input
                v-model.trim="formLabelAlign.operationName"
                placeholder="请输入评分表名称"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="query_btn">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="searchbtn"
              @click="searchData()"
              :loading="sundflag"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              class="searchbtn sonbtn"
              @click.prevent.stop="resetForm('formLabelAlign')"
              >重置</el-button
            >
          </div>
        </div>

        <div class="mian">
          <div class="hos_mian" v-loading="loading">
            <el-table
              ref="tabledata"
              :data="getData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              @selection-change="handleSelectionChange"
              :row-key="getRowKeyOfTarget"
              :header-cell-style="{
                'background-color': '#EEEEEE',
                color: '#333333',
                height: '60px',
              }"
            >
              <!-- <el-table-column
                type="selection"
                width="50px"
                :reserve-selection="true"
                :selectable="handleDisable"
              ></el-table-column> -->
              <!-- 单选 -->
              <el-table-column width="40">
                <template slot-scope="scope">
                  <el-radio
                    class="radio"
                    :label="scope.row"
                    v-model="radio"
                    @change.native="getCurrentRow(scope.row)"
                    >&nbsp;</el-radio
                  >
                </template>
              </el-table-column>

              <el-table-column label="序号" width="50">
                <template slot-scope="scope">
                  {{ scope.$index + (pageIndexs - 1) * eachPageNums + 1 }}
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) in formColumns"
                :key="index"
                :prop="item.prop"
                :label="item.label"
                :width="item.width"
                height="150"
                label-height="50"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div class="foot_box">
              <div class="foot_pagetions">
                <p></p>
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page.sync="pageIndexs"
                  :page-size="eachPageNums"
                  :page-sizes="pagesizesarr"
                  layout="prev, pager, next,sizes, jumper"
                  :total="total"
                  class="pagination"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="determine">确定关联</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { hybrid } from "@/mixin/mixin";
import assessApi from "@/api/assessment";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      labelPosition: "right",
      dialogVisibleObj: {
        addAssociative: false,
      },
      sundflag: false, // 结束考试防抖
      loading: false,
      getData: [], // 表格数据
      radio: "", // 选中的ID
      policyData: {}, // 选中的对象
      formColumns: [
        {
          prop: "Title",
          label: "评分表名称",
        },
        {
          prop: "TotalScore",
          label: "评分表总分",
        },
        {
          prop: "PassScore",
          label: "及格分数",
        },
      ], // 表头
      formLabelAlign: {
        operationName: "", // 操作名称
      },
      getDataCondition: {
        operationName: "", // 操作名称
      },
      multipleSelection: [], // 表单选中
      pageIndexs: 1, // 起始页
      eachPageNums: 5, // mixin定义的获取渲染分页序号有误
      copyArr: [], // 此数组涉及到分页，无法拿到全部的数据去匹配编辑勾选的哪一项，深拷贝一下
    };
  },
  mixins: [hybrid], // 引入共用方法
  methods: {
    // 搜索
    searchData() {
      if (this.formLabelAlign.operationName) {
        this.getDataCondition.operationName = this.formLabelAlign.operationName;
      } else {
        this.getDataCondition.operationName = "";
      }
      this.pageIndexs = 1;
      this.radio = ""; // 勾选清空
      // this.$refs.table.$refs.tabledata.clearSelection(); // 清除勾选状态
      this.getDatalist();
    },
    // 重置
    resetForm() {
      this.pageIndexs = 1;
      this.formLabelAlign.operationName = "";
      this.getDataCondition.operationName = "";
      this.getDatalist();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val; // 批量删除多选状态
      // console.log(this.multipleSelection, "multipleSelection=======>");
      if (val.length >= 1) {
        // this.$message({
        //   message: "当前只能关联一张考核表，",
        //   type: "warning",
        // });
      }
    },
    // 确定
    determine() {
      // this.$emit("list", this.multipleSelection[0]);
      //  this.$parent.titleName = this.multipleSelection[0].Title;
      // this.$parent.operationForm.scoreID = this.multipleSelection[0].ID;
      console.log(this.radio.ID);
      if (this.radio.ID) {
        this.$emit("list", this.radio);
        this.$parent.titleName = this.radio.Title;
        this.$parent.operationForm.scoreID = this.radio.ID;
        this.$refs.tabledata.clearSelection(); // 清除勾选状态
        this.dialogVisibleObj.addAssociative = false;
      } else {
        this.$message({
          message: "警告，请选择需要的关联表",
          type: "warning",
        });
      }
    },
    // 条件禁用
    handleDisable(row) {
      // this.$refs.tabledata.clearSelection()
      let arr = this.multipleSelection.findIndex((v) => v.ID === row.ID);
      let a = this.multipleSelection.length;
      if (a >= 1) {
        if (arr !== -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    // 列表获取
    async getDatalist(type) {
      this.loading = true;
      this.sundflag = true;
      let parameter = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        title: this.getDataCondition.operationName, // 名称
        pageIndex: this.pageIndexs, //当前页
        pageSize: this.eachPageNums, // 一页多少条
      };
      const { data } = await assessApi.getScorelist(parameter);
      if (data.Status == 200) {
        this.getData = data.Data.list;
        this.total = data.Data.dataCount;
        setTimeout(() => {
          this.loading = false;
          this.sundflag = false;
        }, 500);
      } else {
        this.loading = false;
        this.$message.error(data.Msg);
      }
    },
    getCurrentRow(val) {
      this.policyData = val;
      console.log(this.policyData, "===================>>>", this.radio.ID);
    },
    // 编辑列表回显
    async editorList(type) {
      return;
      // 编辑状态回显已勾选中的数据
      if (this.$route.query.type == 1 || this.$route.query.type == 2) {
        let parameter = {
          pageIndex: this.pageIndexs, //当前页
          pageSize: 9999, // 一页多少条
        };
        const { data } = await assessApi.getScorelist(parameter);
        if (data.Status == 200) {
          this.copyArr = JSON.parse(JSON.stringify(data.Data.list));
        }
        let arr = this.copyArr.filter((item) => {
          return item.ID == this.$parent.editorObj.ScoreID; // 找到编辑回显的当前行
        });
        this.multipleSelection = arr; // 赋值进勾选数组
        if (type !== "father") {
          // 父组件调用没有dom，弹窗没有激活
          this.$refs.tabledata.toggleRowSelection(arr[0], true);
        }
        this.$emit(
          "list",
          this.multipleSelection.length != 0
            ? this.multipleSelection[0]
            : { Title: "null" }
        ); // 编辑回显
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.tabledata.toggleRowSelection(row);
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      // this.loading = true;
      this.eachPageNums = val;
      this.getDatalist();
    },
    handleCurrentChange(val) {
      this.pageIndexs = val;
      console.log(`当前页: ${this.pageIndexs}`);
      // this.loading = true;
      this.getDatalist();
    },
    // 唯一key
    getRowKeyOfTarget(row) {
      return row.ID;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
    .el-button {
      width: 100px;
      background: #0084ea;
      border-radius: 2px;
      color: #fff;
    }
  }
  ::v-deep.el-dialog__footer {
    // justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button:nth-child(2) {
    margin-left: 0;
  }
  .mian {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .el-button {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #0084ea;
    }
    p {
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #272636;
      margin: 0;
      span {
        margin-left: 4px;
      }
    }
  }
  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
::v-deep .delete_view .el-dialog {
  width: 800px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}
::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;
  .el-dialog__title {
    color: #fff;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;
  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;
    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }
    &:nth-child(2) {
      background: #0084ea;
    }
  }
}
// 表格
.hos_mian {
  width: 100%;
  padding: 0px 24px;
  margin-top: 24px;
  ::v-deep .el-table th:nth-child(1) {
    opacity: 1;
    border-radius: 4px 0px 0px 4px;
  }
  ::v-deep .el-table th:nth-child(11) {
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
  }
  ::v-deep .el-table th > .cell {
    align-items: center !important;
    text-align: center;
  }
  .operation_box {
    ::v-deep .el-button--text {
      font-size: 16px;
      font-weight: 400;
      // color: #0084ea;
      > span {
        padding-right: 8px;
        border-right: 1px solid #0084ea;
      }
      &:nth-child(3) {
        color: #ff4747;
        > span {
          border-right: none !important;
        }
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #999999 !important;
}
::v-deep .el-table .blue .cell {
  color: #0084ea !important;
}

.operation_ {
  ::v-deep .el-button--text {
    font-size: 16px;
    font-weight: 400;
    // color: #0084ea;
    > span {
      padding-right: 8px;
      border-right: 1px solid #0084ea;
    }
    // margin-right: 20px;
    &:nth-child(4) {
      color: #ff4747;
      > span {
        border-right: none !important;
      }
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 100px;
  ::v-deep .el-pager li:hover {
    color: #0084ea;
  }
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 10px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #0084ea;
        border: none;
      }
    }
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}
::v-deep .el-table .success-row {
  background: #f9f9f9 !important;
}
::v-deep .el-table__cell {
  text-align: center;
}
.cell {
  text-align: center;
}
::v-deep .el-table__header-wrapper {
  .has-gutter {
    // background-color: chocolate;
    > tr {
      > th:nth-child(1) {
        > div {
          .el-checkbox__input {
            display: none;
          }
        }
        //display: none;
      }
    }
  }
}
::v-deep .el-radio__inner {
  border: 1px solid #0084ea !important;
}
.waitingcom_title {
  height: 90px;
  padding: 24px 24px 16px 22px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  align-items: center;
  .el-form {
    display: flex;
    margin-top: 26px !important;
    margin-left: 0px !important;
    ::v-deep .el-input__inner {
      width: 240px !important;
    }
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
::v-deep .el-radio__label{
  display: none !important;
}
</style>
